import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {Tab,Nav} from 'react-bootstrap';
import { format } from 'date-fns';
import ReactHtmlParser from 'react-html-parser';
import { Scrollbars } from 'react-custom-scrollbars';

import BasicInfo from './tabContent/basicInfo';
import Skills from './tabContent/skills';
import Unavailability from './tabContent/unavailability';
import CrewTimesheet from './tabContent/crewTimesheet';  
import CrewFeedback from './tabContent/crewFeedback';  
import CrewVehicleInfo from './tabContent/crewVehicleInfo';  
import CrewNotes from './tabContent/crewNotesTab';  

import Documents from '../commons/documentTab';
import DynamicFieldsDetails from '../commons/dynamicFieldsDetails';

import ModalWindow from '../commons/helpers/modalWindow';
import Toast from '../commons/helpers/toast';
import {titleCase} from '../../utils/changeCase'; 
import {userGroupUrlCheck} from '../../utils/userGroupUrlCheck';
import {LOGIN_AFFILIATE_GROUP,ROUTE_REFRESH,ROUTE_AFFILIATE_REFRESH,ROUTE_AFFILIATE_CREW,TAB1, TAB2, TAB3,TAB4, LOGIN_CREW_GROUP, DYNAMIC_PAGE_ICONS, DEFAULT_TIME_ZONE, DEFAULT_COUNTRY_NAME, DEFAULT_COUNTRY_CODE, STR_VEHICLE_INFO,DEFAULT_GENDER} from '../../configs/staticConfigs';
import { MSG_MAIL_RESEND, MSG_MAIL_RESEND_ERROR, MSG_LOGO_FORMAT, MSG_REQUIRED,MSG_CREW_INFO_UPDATE, MSG_CREW_INFO_SAVE, MSG_CREW_INFO_SAVE_NO_EMAIL, MSG_AVAILABILITY_STATUS,MSG_FILE_SIZE_ERROR, MSG_FILE_FORMAT_ERROR, MSG_DYNAMIC_FIELD_DATA_SAVE_SUCCESS, MSG_DYNAMIC_FIELD_DATA_SAVE_ERROR, MSG_ERROR,MSG_CREW_INFO_EMAIL_UPDATE,MSG_TIMEZONE_DATA_ERROR,MSG_CREW_APPROVE_ERROR,MSG_CREW_AVAILABILITY_ERROR, MSG_DATA_SAVE_ERROR,MSG_CREW_ACTIVATED,MSG_STATUS_UPDATED, MSG_CREW_DELETED,MSG_CREW_APPROVE_PAYLEVEL_ERROR, MSG_CREW_INDUCTION_ERROR, MSG_CREW_CHIEF_APPROVE_ERROR, MSG_CREW_DEACTIVATED } from '../../configs/msgConfigs';
import { LBL_VEHICLE_INFO,LBL_APP_NAME, LBL_SETTINGS, LBL_COMPANY_PROFILE, LBL_BASIC_INFO, LBL_UNAVAILABILITY, LBL_SKILLS, LBL_DOCUMENTS, LBL_CREW_INDUCTION_COMPLETED_Q, LBL_VERIFY_CREW_DOCUMENTS_Q, LBL_VERIFY_CREW_CHIEF_Q, LBL_VERIFY_CREW_CHIEF_NO_Q,LBL_ACTIVATE,LBL_DEACTIVATE, LBL_ACTIONS, LBL_CREW, LBL_CREW_ADD, LBL_CREW_EDIT,LBL_TIMESHEET, LBL_FEEDBACK, LBL_NOTES } from '../../configs/labelConfigs';
import {validationMsgCrewAdd,validationMsgCrewDetails} from '../../configs/validationConfigs';

import { crewBasicInfoAddAction,crewBasicInfoUpdateAction, crewEditAction, crewActiveDeactiveAction,
crewChangeAvailabilityAction, crewApproveAction, crewChiefEligibleAction,crewInductionAction} from '../../actions/crewActions';
import {validateCrewAddAction,validateCrewDetailsAction} from '../../actions/validateActions'; 

import {aflt_departmentsListAction} from '../../actions/settings/affiliates/aflt_departmentActions';
import {clearAction,resendEmailAction,timeZonesListAction,fromExpiryCertificates} from '../../actions/commonActions';
import { listVehicleInfo} from '../../actions/settings/affiliates/vehicleInfoAction';

import { dynamicFieldsListAction, dynamicFieldsDataSaveAction } from '../../actions/settings/dynamicFieldsActions'; 
import { payLevelsListAction } from '../../actions/settings/affiliates/payLevelsActions'; 
import * as types from '../../actions';

import {formValid, validateEmail,fileSize,imageExtension} from '../../utils/validation';

import {checkPermissions} from '../../utils/permissions';

import * as gLoc from '../../configs/googleConfigs'; 
import {geocodeByAddress,getLatLng} from 'react-places-autocomplete';

import {countryListAction} from '../../actions/commonActions';
import {format as stringFormat} from 'react-string-format';
import getCroppedImg from '../commons/image-cropper/cropImage';
import Cropper from 'react-easy-crop';
import 'react-easy-crop/react-easy-crop.css';
// import { COUNTRY_LIST_SUCCESS,COUNTRY_LIST_ERROR } from '../../actions';


class CrewProfileComponent extends Component {

    constructor(props){
        super(props)

        let affiliateId   = '';
        let associateId  = ''; 
        let userGroupData = userGroupUrlCheck(window.location);
        if(userGroupData!==undefined){
            affiliateId   = userGroupData.profile_id;
            associateId   = userGroupData.associate_id;
        }

        // let crewId    = (this.props.match && this.props.match.params && this.props.match.params.id) ? this.props.match.params.id : this.props.activeCrewId ? this.props.activeCrewId : 0;
        let crewId = this.props.activeCrewId;

        this.state = {                    
            formErrors:{
                firstName: MSG_REQUIRED,
                lastName: MSG_REQUIRED,
                preferedName: MSG_REQUIRED,
                contactNumber: MSG_REQUIRED,
                emailAddress: MSG_REQUIRED,
                gender: '',
                streetOne:'',
                streetTwo:'',
                city:'',
                state:'',
                country:'',
                postcode:'', 
                nationality: MSG_REQUIRED,
                timeZone: MSG_REQUIRED, 
                payLevel: MSG_REQUIRED,
                department: MSG_REQUIRED,   
                locationName: MSG_REQUIRED, 
            },          
            crewData:{
                basicInfo:{
                    id: null,
                    firstName: null,
                    lastName: null,
                    preferedName: null,
                    contactNumber:null,
                    emailAddress:null, 
                    alternateContactNum:'',
                    gender:DEFAULT_GENDER,
                    dob:'',
                    nationality:null,
                    department: [],                  
                    googleLocation:'',
                    venue:'',  
                    streetOne:'',
                    streetTwo:'',
                    city:null,
                    state:null,
                    country:null,
                    postcode:null,
                    passport:null,
                    visa:null,
                    additionalText:'',
                    logo:'',    
                    affiliateId:affiliateId,
                    emailVerify:false,
                    userId:'',
                    timeZone:null,  
                    crewStarRatings:0,
                    isInducted:false,
                    isApproved:false,   
                    isInducted_server:false,
                    isApproved_server:false,   
                    payLevel:null,
                    chkSendVerifyEmail:true,
                    has_vehicle:true
                },            
                activeTab:"company-info-tab",
            }, 
            crewId:crewId,
            imgUrl:null,   
            toastMessage:'',
            toastFlag:false,
            toastSuccess:true,      
            formClick:false,         
            lastlogin:'',
            ppPoints:'',
            omnuPoints:'',
            availabilityStatus:false,
            chiefEligibility:false,
            driveToShiftLocation:false,
            logoLabel:'',
            isLogoValid:true,
            userType:LOGIN_CREW_GROUP, 
            listDynData: {groupId: 0, reqFrom:0},
            dynFieldsAllItems: [],  
            dynFieldsActiveItem: { id: 0, name: '', field_details: [], user_type: 0, show_tab: true, icon_name: '' },    
            activePageId: 0, 
            dynamicFieldsSavedData: [],
            locGoogleCodes: {
                streetOne:'',
                streetTwo:'',
                city:'',
                state:'',
                country:'',
                postcode:'',   
            },  
            arrCountryList: [], 
            timeZonesList: [], 
            defaultTimeZoneId:0,   
            deptMultiSelList: [], 
            departmentsList: [],
            validationMsgArr: [], 
            activeDeactiveText: '',
            image: '',
            crop: { x: 0, y: 0 },
            zoom: 1,
            aspect: 4 / 4,
            croppedArea:{},
            croppedAreaPixels:{},
            rotation:0,
            imgObj:null,
            crewHeading: '',
            addNewButtonClicked: 0,
            crewActivatedSuccess: 0, 
            crewDeactivatedSuccess: 0,
            timesheetCrewId: 0,
            feedbackCrewId: 0, 
            vehicleCrewId: 0, 
            editCreDetailsCalled: false,
            affiliateId:affiliateId,
            associateId:associateId,
            loadCrewNotes:0,
            defaultNationality: 0,
            defaultPaylevelId: 0,
        }

        this.onHandleChange         = this.onHandleChange.bind(this);
        this.saveFormData           = this.saveFormData.bind(this);
        this.onTabChange            = this.onTabChange.bind(this);
        this.onAvailabilityChange   = this.onAvailabilityChange.bind(this);
        this.deleteCrew             = this.deleteCrew.bind(this);
        this.onApproveCrew          = this.onApproveCrew.bind(this);
        this.setToasterState        = this.setToasterState.bind(this);
        this.changePage             = this.changePage.bind(this);   
        this.loadMultiSelDeptValues = this.loadMultiSelDeptValues.bind(this); 

        this.modalCrewInduction = React.createRef(); 
        this.modalCrewApprove = React.createRef(); 
        this.modalCrewChiefEligible = React.createRef(); 
        this.logoModalCropper = React.createRef(); 
    }

    reloadParentCrewList = () => {
        this.props.callCrewListAction(); 
    }

    callCertificateListAction = () => {
        this.props.callCertificateListAction(); 
    }

    resetStateOnCrewAdd = (crewId,addNewButtonClicked) => {
        let affiliateId = this.state.crewData.basicInfo.affiliateId;   
        let allDept = []; 
        let deptId = 0; 
        if(this.state.departmentsList.length > 0) {
           let tmpObj = {}; 
           let len = this.state.departmentsList.length; 
           this.state.departmentsList.forEach((item,index) => { 
               if(len===1) {
                   tmpObj = {value:item.id, label:titleCase(item.name), inputVal:item.id}; 
                   deptId = item.id;   
               }
               else {
                   tmpObj = {value:item.id, label:titleCase(item.name)}; 
               }
              allDept.push(tmpObj); 
           }) 
        }
        else {
            this.props.aflt_departmentsListAction({associated:'1'});
        }

        let dn = this.state.defaultNationality; 
        let tz = this.state.defaultTimeZoneId; 
        let pl = this.state.defaultPaylevelId;

        this.setState({
            formErrors:{
                firstName: MSG_REQUIRED,
                lastName: MSG_REQUIRED,
                preferedName: MSG_REQUIRED,
                contactNumber: MSG_REQUIRED,
                emailAddress: MSG_REQUIRED,
                gender: '',
                streetOne:'',
                streetTwo:'',
                city:'',
                state:'',
                country:'',
                postcode:'', 
                nationality: dn==0 ? MSG_REQUIRED : '',
                timeZone: tz==0 ? MSG_REQUIRED : '', 
                payLevel: pl==0 ? MSG_REQUIRED : '',
                department: deptId > 0 ? '' : MSG_REQUIRED,  
                locationName: MSG_REQUIRED,                         
            },       
            crewData:{
                basicInfo:{
                    firstName: null,
                    lastName: null,
                    contactNumber:null,
                    emailAddress:null, 
                    alternateContactNum:'',
                    gender:DEFAULT_GENDER,
                    dob:'',
                    nationality:dn==0 ? null : dn,
                    department: deptId > 0 ? [deptId] : [],                  
                    googleLocation:'',
                    venue:'',  
                    streetOne:'',
                    streetTwo:'',
                    city:null,
                    state:null,
                    country:null,
                    postcode:null,
                    additionalText:'',
                    logo:'',    
                    isApproved:false,  
                    affiliateId:affiliateId,                  
                    emailVerify:false,
                    userId:'',
                    timeZone:tz,  
                    crewStarRatings:0,
                    isInducted:false,
                    payLevel:pl > 0 ? pl : null,
                    chkSendVerifyEmail:true,
                    has_vehicle:false
                },                    
                activeTab:"company-info-tab"                     
            },            
            crewId:crewId,
            imgUrl:null,   
            toastMessage:'',
            toastFlag:false,
            toastSuccess:true,      
            formClick:false,         
            lastlogin:'',
            ppPoints:'',
            omnuPoints:'',
            availabilityStatus:false,
            chiefEligibility:false,
            driveToShiftLocation:false,
            logoLabel:'',
            isLogoValid:true,
            userType:LOGIN_CREW_GROUP, 
            listDynData: {groupId: 0, reqFrom:0},
            dynFieldsAllItems: [],  
            dynFieldsActiveItem: { id: 0, name: '', field_details: [], user_type: 0, show_tab: true, icon_name: '' },    
            activePageId: 0, 
            dynamicFieldsSavedData: [],
            locGoogleCodes: {
                streetOne:'',
                streetTwo:'',
                city:'',
                state:'',
                country:'',
                postcode:'',   
            },  
            defaultTimeZoneId:this.state.defaultTimeZoneId?this.state.defaultTimeZoneId:0,   
            validationMsgArr: [], 
            activeDeactiveText: '',
            image: '',
            crop: { x: 0, y: 0 },
            zoom: 1,
            aspect: 4 / 4,
            croppedArea:{},
            croppedAreaPixels:{},
            rotation:0,
            imgObj:null,
            crewHeading: '',
            addNewButtonClicked:addNewButtonClicked,
            crewActivatedSuccess: 0, 
            crewDeactivatedSuccess: 0,
            deptMultiSelList:allDept,
        }, () => {
            this.onTabChange('', "company-info-tab"); // SHOW BASIC INFO TAB
        }); 
    }

    onHideFilterBy = () => {     
        document.getElementById("filterByMenu").classList.remove('active'); 
        let filterByMenu = document.getElementById('filterByMenu');
        let filterTab = document.getElementById('filterTab');
        let quoteTab = document.getElementById('detailTab');
        filterTab.style.display = 'block';
        quoteTab.style.display = 'none';  
        filterByMenu.style.width='450px';  
        filterByMenu.style.right='-1000px';
        let crewData = this.state.crewData;
        crewData['activeTab'] = (this.props.calledFrom && this.props.calledFrom==='certificates') ?'documents-tab' : "company-info-tab"; 
        this.setState({crewData}); 
        // if(this.props.needparentCallback && this.props.needparentCallback==='yes') {
        //     this.props.onEventDetailsClose(); 
        // } 
    }  

    callValidate = () => {
        if(this.state.crewId) this.props.validateCrewDetailsAction(this.state.crewId);
    }

    loadMultiSelDeptValues() {
        let allDept = []; 
        if(this.state.departmentsList.length > 0) {
           let tmpObj = {}; 
           let len = this.state.departmentsList.length; 
           let deptId = 0;  
           this.state.departmentsList.forEach((item,index) => { 
               if(len===1) {
                   tmpObj = {value:item.id, label:titleCase(item.name), inputVal:item.id}; 
                   deptId = item.id;   
               }
               else {
                   tmpObj = {value:item.id, label:titleCase(item.name)}; 
               }
              allDept.push(tmpObj); 
           }) 
           
            if(len===1 && deptId > 0) {
                let actUserData = this.state.crewData; 
                let formErrors = this.state.formErrors;
                formErrors.department = ""; 
                actUserData.basicInfo.department = [deptId]; 
                this.setState({crewData:actUserData,deptMultiSelList:allDept,formErrors}); 
            }
            else {
                this.setState({deptMultiSelList:allDept}); 
            }
        }
     }

    handleChangeMultiSel = (selectedDepts) =>{
        let actUserDept = []; 
        selectedDepts.forEach((item) => {
           actUserDept.push(item.value);
        });
        let actUserData = this.state.crewData; 
        actUserData.basicInfo.department = actUserDept; 

        let formErrors = this.state.formErrors; // department  
        actUserData.basicInfo.department = actUserDept; 
        formErrors.department = actUserDept.length===0 ? MSG_REQUIRED : ''; 
        this.setState({crewData:actUserData,formErrors}); 
    }
  

    changePage = (event, refPageId) => {
        if(this.state.activePageId!==refPageId) {
            let allPagesFieldsObj = []; 
            let newActiveObj = {};
            this.state.dynFieldsAllItems.forEach((item,index) => {
                if(item.id===this.state.activePageId) allPagesFieldsObj.push(this.state.dynFieldsActiveItem); 
                else allPagesFieldsObj.push(item); 
                if(item.id===refPageId)  {
                    newActiveObj = item;
                }
            }); 
            this.setState({activePageId:refPageId, dynFieldsActiveItem: newActiveObj, dynFieldsAllItems:allPagesFieldsObj,toastFlag:false,toastMessage:'',toastSuccess:true}); 
        }   
    }

    onDateChange = (date) =>{
        let crewData   = this.state.crewData;     
        let basicInfo  = this.state.crewData.basicInfo;
        basicInfo['dob'] = format(new Date(date), 'yyyy-MM-dd')+" 00:00:00";
        this.setState({crewData});
    }

    onPhoneInputChange = (value, data, event, formattedValue) =>{
        let crewData   = this.state.crewData;     
        let formErrors   = this.state.formErrors;     
        let basicInfo  = this.state.crewData.basicInfo;
        basicInfo['contactNumber'] = formattedValue;
        formErrors.contactNumber = value.trim()===data.dialCode ? MSG_REQUIRED : ""
        formErrors.contactNumber = formattedValue.trim().length<5 ? MSG_REQUIRED : ""

        this.setState({formErrors,crewData});
    }
    onAlternatePhoneInputChange = (value, data, event, formattedValue) =>{
        let crewData   = this.state.crewData;     
        let basicInfo  = this.state.crewData.basicInfo;
        basicInfo['alternateContactNum'] = formattedValue.trim();
        
        this.setState({crewData});
    }

    onHandleChange = (e, tab) =>{
        const {name}  = e.target;
        let value     = '';

        switch(e.target.type){
            case 'file':
                value = e.target.files[0];
                break;
            case 'checkbox':
                value = e.target.checked;
                break;
            default:
                value = e.target.value;
                break;
        }
        let formErrors      = this.state.formErrors;
        let logoValid       = true;
        let logoError       = ''; // MSG_LOGO_FORMAT; 

        let trimmedValue = '';
        if(e.target.type==="text" || e.target.type==="tel" || e.target.type==="email"){
            trimmedValue = value.trim(); 
        }

        switch(name){
            case 'logo':
                if (!fileSize(value.size)) {
                    logoError     = MSG_FILE_SIZE_ERROR;
                    logoValid = false;
                }
                if(!imageExtension(value.name)){
                    logoError     = MSG_LOGO_FORMAT; // MSG_FILE_FORMAT_ERROR;
                    logoValid = false;
                }      
                break; 
            case 'firstName':
                formErrors.firstName = 
                trimmedValue.length <=0 
                ? MSG_REQUIRED
                : ""
                break;  
            case 'lastName':
                formErrors.lastName = 
                trimmedValue.length <=0 
                ? MSG_REQUIRED
                : ""
                break;  
            case 'preferedName':
                formErrors.preferedName = 
                trimmedValue.length <=0 
                ? MSG_REQUIRED
                : ""
                break;   
            case 'contactNumber':
                formErrors.contactNumber = 
                trimmedValue.length <=0 
                ? MSG_REQUIRED
                : ""
                break;   
            
            case 'emailAddress':
                formErrors.emailAddress = 
                trimmedValue.length <=0 || validateEmail(trimmedValue) === false
                ? MSG_REQUIRED
                : ""
            break;                 
            case 'gender':
                formErrors.gender = 
                value.length <=0 || Number(value)===0
                ? MSG_REQUIRED
                : ""
                break;  
            case 'nationality':
                formErrors.nationality = 
                value.length <=0 || Number(value)===0
                ? MSG_REQUIRED
                : ""
                break;  
            // case 'streetOne':
            //     formErrors.streetOne = 
            //     trimmedValue.length <=0 
            //     ? MSG_REQUIRED
            //     : ""
            //     break;   
            // case 'streetTwo':
            //     formErrors.streetTwo = 
            //     trimmedValue.length <=0 
            //     ? MSG_REQUIRED
            //     : ""
            //     break;   
            case 'city':
                formErrors.city = 
                trimmedValue.length <=0 
                ? MSG_REQUIRED
                : ""
                break;    
            case 'state':
                formErrors.state = 
                trimmedValue.length <=0 
                ? MSG_REQUIRED
                : ""
                break;   
            case 'country': formErrors.country = trimmedValue.length <=0 ? MSG_REQUIRED : "";
                break;       
            case 'postcode':
                formErrors.postcode = 
                trimmedValue.length <=0 
                ? MSG_REQUIRED
                : ""
                break;  
            case 'timeZone':
                formErrors.timeZone = (value.length <=0 || Number(value)===0) ? MSG_REQUIRED : ""; 
                break;   
            case 'payLevel':
                formErrors.payLevel = (value.length <=0 || Number(value)===0) ? MSG_REQUIRED : ""; 
                break;          
            default :
            break;
        }

        let crewData         = this.state.crewData;      
        let basicInfo        = this.state.crewData.basicInfo;

        if(tab==="company-info-tab"){
            if(name==='logo' && logoError==='') {
                basicInfo[name] = value; 
            }
            else if(name!=='logo') {
                basicInfo[name] = value;
            }
        }
        
        if(e.target.type=== "file"){
            let imgUrl = '';
            let imgObj = null;
            if(imageExtension(e.target.files[0].name) && logoError===''){
                imgObj = e.target.files[0]
                imgUrl = URL.createObjectURL(e.target.files[0]);
                this.setState({imgUrl:imgUrl,imgObj:imgObj});
                document.getElementById('uploadLogo').value = '';
                this.openCropModal();
            }
        }
              
        this.setState({formErrors,crewData,isLogoValid:logoValid,logoLabel:logoError});
    }

    onCropChange = crop => {
        this.setState({ crop })
    }
 
    onCropComplete = (croppedArea, croppedAreaPixels) => {
        this.setState({croppedArea:croppedArea,croppedAreaPixels:croppedAreaPixels})
    }
 
    onZoomChange = zoom => {
        this.setState({ zoom })
    }

    openCropModal =() =>{
        this.logoModalCropper.current.handleOpenModal();
    }

    cropImage(e,cropModule){
        let {imgObj,croppedAreaPixels,rotation,imgUrl} = this.state
        const obj = this;
        let canvas = getCroppedImg(
            imgObj,
            croppedAreaPixels,
            obj,
            rotation,
            'crewProfile'
        )

    }

    onTabChange = (e,tab) =>{
        let crewData = this.state.crewData;
        crewData['activeTab'] = tab;
        if(tab==='timesheet-tab') {
            let crewId = this.state.crewId;
            this.setState({crewData, timesheetCrewId:crewId});    
        }    
        else if(tab==='feedback-tab') {
            let crewId = this.state.crewId;
            this.setState({crewData, feedbackCrewId:crewId});    
        }else if(tab==='crew-vehicle-info-tab') {
            let crewId = this.state.crewId;
            this.setState({crewData}); 
            this.props.listVehicleInfo(this.state.crewId)   
        }  
        else if(tab==='crew-notes-tab') {
            this.setState({loadCrewNotes:(this.state.loadCrewNotes+1)}); 
        } 
        else {
            this.setState({crewData});    
        }
    }    
    
    onCloseToast = () =>{
        this.setState({toastFlag:false,toastMessage:'',toastSuccess:false});
    } 

    setToasterState(isEnabled,message,isSucces,isAutoHide=true){
        this.setState({toastFlag:isEnabled,toastMessage:message,toastSuccess:isSucces});
        if(isAutoHide){
            setTimeout(()=> {
                this.onCloseToast();
            }, 4000);
        }    
    }
  
    saveFormData = (e, tab)=>{
        e.preventDefault();
        this.setState({formClick:true});
        const crewId     = this.state.crewId; 
        const data       = new FormData(); 
        const formErrors = this.state.formErrors;
        if(tab==="company-info-tab"){
            const {basicInfo} = this.state.crewData;
            if(basicInfo.payLevel && Number(basicInfo.payLevel) > 0 && basicInfo.department.length > 0 && formValid(this.state)){ 
                let location = basicInfo.venue+', '+basicInfo.streetOne+', '+basicInfo.streetTwo+', '+basicInfo.city+', '+basicInfo.state+', '+basicInfo.country+', '+basicInfo.postcode;       
                let user = {
                    'first_name':basicInfo.firstName, 
                    'last_name':basicInfo.lastName, 
                    'email':basicInfo.emailAddress, 
                    'username': basicInfo.emailAddress
                };                
                
                data.append('user', JSON.stringify(user)); 

                data.append('prefered_name',basicInfo.preferedName); 
                data.append('location',location); 
                data.append('lat_long',basicInfo.googleLocation); 
                data.append('venue',basicInfo.venue); 
                data.append('street1',basicInfo.streetOne); 
                data.append('street2',basicInfo.streetTwo); 
                data.append('city',basicInfo.city); 
                data.append('state',basicInfo.state); 
                data.append('country',basicInfo.country); 
                data.append('postcode',basicInfo.postcode); 

                data.append('phone_number', basicInfo.contactNumber);
                data.append('altername_number', basicInfo.alternateContactNum);
                data.append('gender', basicInfo.gender);
                data.append('date_of_birth', basicInfo.dob?basicInfo.dob.split(' ')[0]:basicInfo.dob);
                data.append('nationality', basicInfo.nationality);
                data.append('department', JSON.stringify(basicInfo.department)); 
                // data.append('department', basicInfo.department.join(','));
                // if(basicInfo.department.length) {
                //     basicInfo.department.forEach(item => {
                //         data.append('department[]', Number(item));
                //     }); 
                // }
                // else {
                //     data.append('department[]', '');
                // }
                data.append('email_verified', basicInfo.emailVerify);
                data.append('affiliate', basicInfo.affiliateId);
                data.append('notes', basicInfo.additionalText);                  
                data.append('time_zone', basicInfo.timeZone);   
                data.append('pay_level', basicInfo.payLevel>0?basicInfo.payLevel:'');                                  

                if(basicInfo.logo!==''){
                    data.append('profile_picture', basicInfo.logo);
                }               

                if(crewId===undefined){
                    data.append('send_email_verification', basicInfo.chkSendVerifyEmail);  
                    this.props.crewBasicInfoAddAction(data);
                }else{
                    data.append('id', crewId);  
                    data.append('is_inducted', basicInfo.isInducted);
                    data.append('is_approved', basicInfo.isApproved);                    
                    data.append('chief_eligibility', this.state.chiefEligibility);
                    data.append('availability_status', this.state.availabilityStatus);    
                    data.append('drive_to_shift_location', this.state.driveToShiftLocation);    

                    this.props.crewBasicInfoUpdateAction(data);
                }           
            }else{
                if(basicInfo.department.length===0) {
                    formErrors.department = MSG_REQUIRED;
                }
                if(basicInfo.firstName===null){
                    formErrors.firstName = MSG_REQUIRED;
                }
                if(basicInfo.lastName===null){
                    formErrors.lastName = MSG_REQUIRED;
                }
                if(basicInfo.emailAddress===null){
                    formErrors.emailAddress = MSG_REQUIRED;
                }
                if(basicInfo.contactNumber===null){
                    formErrors.contactNumber = MSG_REQUIRED;
                }
                if(basicInfo.gender===null){
                    formErrors.gender = MSG_REQUIRED;
                }  
                if(basicInfo.nationality===null){
                    formErrors.nationality = MSG_REQUIRED;
                }              
                // if(basicInfo.streetOne===null){
                //     formErrors.streetOne = MSG_REQUIRED;
                // }  
                // if(basicInfo.streetTwo===null){
                //     formErrors.streetTwo = MSG_REQUIRED;
                // }  
                if(basicInfo.city===null){
                    formErrors.city = MSG_REQUIRED;
                }  
                if(basicInfo.state===null){
                    formErrors.state = MSG_REQUIRED;
                }  
                if(basicInfo.country===null){
                    formErrors.country = MSG_REQUIRED;
                }  
                if(basicInfo.postcode===null){
                    formErrors.postcode = MSG_REQUIRED;
                }    
                if(basicInfo.timeZone===null){
                    formErrors.timeZone = MSG_REQUIRED;
                }          
                if(basicInfo.payLevel===null || Number(basicInfo.payLevel)==0){
                    formErrors.payLevel = MSG_REQUIRED;
                } 
                this.setState({formErrors});
            }
        }
    }

    onModalFormReset = () =>{
        this.setState({
            chiefEligibility:false
        })
    }

    onModalFormResetInduction = () => {
        document.getElementById('chkInductionCrew').checked = false; 
    }

    onModalFormResetApproval = () => {
        document.getElementById('chkApproveCrew').checked = false; 
    }

    deleteCrew = (e) =>{
        if(this.state.crewId){
            let data = {
                is_active:false,
                profileId:this.state.crewId
            }
            this.setState({activeDeactiveText:LBL_DEACTIVATE}, () => {
                this.props.crewActiveDeactiveAction(data);
            });
        }
    }

    activateCrew = (e) =>{
        if(this.state.crewId){
            let data = {
                is_active:true,
                profileId:this.state.crewId
            }
            this.setState({activeDeactiveText:LBL_ACTIVATE}, () => {
                this.props.crewActiveDeactiveAction(data);
            }); 
        }
    }

    onAvailabilityChange = (e) =>{
        this.setState({ 
            availabilityStatus: e.target.checked 
        });    
    }

    onDriveToShiftLocationChange = (e) =>{
        this.setState({ 
            driveToShiftLocation: e.target.checked 
        });    
    }

    approveCrewModalOpen = (e) => {
        // INDUCTION, APPROVE, SUPERVISOR, AVAILABILITY ARE NOT INDIVICUAL FUNCTIONS FROM 15Jan2021 - CUSTOMER REQUEST
        // let plLength = this.props.payLevelList && Array.isArray(this.props.payLevelList) ? this.props.payLevelList.length : 0; 
        // if(plLength > 0 && !this.state.crewData.basicInfo.payLevel || Number(this.state.crewData.basicInfo.payLevel)===0) {
        //     this.setToasterState(true,MSG_CREW_APPROVE_PAYLEVEL_ERROR,false,true); 
        // }
        // else {
        //     this.modalCrewApprove.current.handleOpenModal();
        // } 
        let availabilityStatus = e.target.checked; 

        let plLength = this.props.payLevelList && Array.isArray(this.props.payLevelList) ? this.props.payLevelList.length : 0; 
        if(plLength > 0 && !this.state.crewData.basicInfo.payLevel || Number(this.state.crewData.basicInfo.payLevel)===0) {
            this.setToasterState(true,MSG_CREW_APPROVE_PAYLEVEL_ERROR,false,true); 
        }
        else {
            let crewData         = this.state.crewData;
            crewData.basicInfo.isApproved = !this.state.crewData.basicInfo.isApproved;
            if(!this.state.crewData.basicInfo.isApproved) crewData.basicInfo.isApproved = false; 
            this.setState({crewData,availabilityStatus});
        } 
    }

    onApproveCrew = (e) =>{ 
        if(e.target.checked) {
            this.setState({availabilityStatus: true});   
        }
        // let data = {
        //     is_approved:true,
        //     profileId:this.state.crewId
        // }
        // this.props.crewApproveAction(data);
    }

    inductionCrewModalOpen = ()=>{
        // INDUCTION, APPROVE, SUPERVISOR, AVAILABILITY ARE NOT INDIVICUAL FUNCTIONS FROM 15Jan2021 - CUSTOMER REQUEST
        // this.modalCrewInduction.current.handleOpenModal();
        let crewData         = this.state.crewData;
        crewData.basicInfo.isInducted = !this.state.crewData.basicInfo.isInducted;
        if(!this.state.crewData.basicInfo.isInducted) crewData.basicInfo.isApproved = false; 
        this.setState({crewData});
    }

    onInductionCrew = () =>{
        // INDUCTION, APPROVE, SUPERVISOR, AVAILABILITY ARE NOT INDIVICUAL FUNCTIONS FROM 15Jan2021 - CUSTOMER REQUEST
        // let data = {
        //     is_inducted:true,
        //     profileId:this.state.crewId
        // }
        // this.props.crewInductionAction(data);
    }

    chiefEligibleModalOpen = (e)=>{
        this.setState({ 
            chiefEligibility: e.target.checked 
        });
        // INDUCTION, APPROVE, SUPERVISOR, AVAILABILITY ARE NOT INDIVICUAL FUNCTIONS FROM 15Jan2021 - CUSTOMER REQUEST
        // this.modalCrewChiefEligible.current.handleOpenModal();
    }

    onChiefEligibility = (e) =>{
        // this.setState({ 
        //     chiefEligibility: e.target.checked 
        // });
        // INDUCTION, APPROVE, SUPERVISOR, AVAILABILITY ARE NOT INDIVICUAL FUNCTIONS FROM 15Jan2021 - CUSTOMER REQUEST
        // let data = {
        //     chief_status:this.state.chiefEligibility,
        //     profileId:this.state.crewId
        // }
        // this.props.crewChiefEligibleAction(data);
    }

    resendEmail =(userId)=>{
        this.props.resendEmailAction(userId);
    }

    googleLocSelect = (address) =>{ 
        let {formErrors} = this.state; 
        let crewData = this.state.crewData; 
        let locGoogleCodes  = this.state.locGoogleCodes; 

        geocodeByAddress(address)
        .then(results => {            
            crewData.basicInfo.streetOne = ''; 
            crewData.basicInfo.streetTwo = ''; 
            crewData.basicInfo.city = ''; 
            crewData.basicInfo.state = ''; 
            crewData.basicInfo.country = ''; 
            crewData.basicInfo.postcode = '';   
            // crewData.basicInfo.location = results[0].formatted_address;  
            let tmpArr = [];
            tmpArr = address.split(','); 
            crewData.basicInfo.venue = tmpArr[0]; 

            locGoogleCodes.streetOne = ''; 
            locGoogleCodes.streetTwo = ''; 
            locGoogleCodes.city = ''; 
            locGoogleCodes.state = ''; 
            locGoogleCodes.country = ''; 
            locGoogleCodes.postcode = ''; 

            let allAddress = results[0].address_components;
            let addrTypes = []; 
            let foundVar = 0; 
            let tmpVal = ''; 
            allAddress.forEach(element => {
                addrTypes = element.types;
                foundVar = 0; 
                addrTypes.forEach(item => {
                    tmpVal = element.long_name.trim().length ? element.long_name.trim() : ((element.short_name.trim().length) ? element.short_name.trim() : '') ;
                    if(foundVar===0 && tmpVal!=='') { 
                        if(gLoc.GOOGLE_LOCATION_STREET.includes(item)) {
                            foundVar = 1; 
                            if(crewData.basicInfo['streetOne'].trim()==='') crewData.basicInfo['streetOne'] = tmpVal; 
                            else crewData.basicInfo['streetOne'] += ', '+tmpVal;  

                            if(locGoogleCodes['streetOne'].trim()==='') locGoogleCodes['streetOne'] = item; 
                            else locGoogleCodes['streetOne'] += ', '+item; 
                        } 
                        else if(gLoc.GOOGLE_LOCATION_STREET2.includes(item)) {
                            foundVar = 1; 
                            if(crewData.basicInfo['streetTwo'].trim()==='') crewData.basicInfo['streetTwo'] = tmpVal; 
                            else crewData.basicInfo['streetTwo'] += ', '+tmpVal; 
                            if(locGoogleCodes['streetTwo'].trim()==='') locGoogleCodes['streetTwo'] = item; 
                            else locGoogleCodes['streetTwo'] += ', '+item; 
                        } 
                        else if(gLoc.GOOGLE_LOCATION_CITY.includes(item)) {
                            foundVar = 1; 
                            if(crewData.basicInfo['city'].trim()==='') crewData.basicInfo['city'] = tmpVal; 
                            else crewData.basicInfo['city'] += ', '+tmpVal; 
                            if(locGoogleCodes['city'].trim()==='') locGoogleCodes['city'] = item; 
                            else locGoogleCodes['city'] += ', '+item; 
                        } 
                        else if(gLoc.GOOGLE_LOCATION_STATE.includes(item)) {
                            foundVar = 1; 
                            if(crewData.basicInfo['state'].trim()==='') crewData.basicInfo['state'] = tmpVal; 
                            else crewData.basicInfo['state'] += ', '+tmpVal; 
                            if(locGoogleCodes['state'].trim()==='') locGoogleCodes['state'] = item; 
                            else locGoogleCodes['state'] += ', '+item; 
                        } 
                        else if(gLoc.GOOGLE_LOCATION_COUNTRY.includes(item)) {
                            foundVar = 1; 
                            if(crewData.basicInfo['country'].trim()==='') crewData.basicInfo['country'] = tmpVal; 
                            else crewData.basicInfo['country'] += ', '+tmpVal; 
                            if(locGoogleCodes['country'].trim()==='') locGoogleCodes['country'] = item; 
                            else locGoogleCodes['country'] += ', '+item; 
                        }
                        else if(gLoc.GOOGLE_LOCATION_POSTCODE.includes(item)) {
                            foundVar = 1; 
                            if(crewData.basicInfo['postcode'].trim()==='') crewData.basicInfo['postcode'] = tmpVal; 
                            else crewData.basicInfo['postcode'] += ', '+tmpVal; 
                            if(locGoogleCodes['postcode'].trim()==='') locGoogleCodes['postcode'] = item; 
                            else locGoogleCodes['postcode'] += ', '+item; 
                        }
                    }
                })
            })

            getLatLng(results[0]).then(latLng=>{
                crewData.basicInfo['googleLocation'] = latLng.lat+','+latLng.lng;
            })
        }).then( () => {
            formErrors['streetOne'] = '';
            formErrors['city'] = '';
            formErrors['state'] = '';
            formErrors['country'] = '';
            formErrors['postcode'] = '';
            formErrors['locationName'] = '';
            this.setState({crewData:crewData,locGoogleCodes:locGoogleCodes,formErrors});
        })
        .catch(error => console.error('Error', error));
    }

    onGetGoogleLoc = (e) =>{
        const {name}  = e.target;
        let crewData = this.state.crewData;        
        crewData.basicInfo[name] = e.target.checked;
        // const instance = this._typeahead.getInstance()
        // instance.clear();
        crewData.basicInfo['locationId'] = '';
        // crewData.basicInfo['venue'] = '';
        crewData.basicInfo['googleLocation'] = '';
        crewData.basicInfo['venue'] = '';
        crewData.basicInfo['streetOne'] = '';
        crewData.basicInfo['streetTwo'] = '';
        crewData.basicInfo['city'] = '';
        crewData.basicInfo['state'] = '';
        crewData.basicInfo['country'] = '';
        crewData.basicInfo['postcode'] = '';
        this.setState({crewData});
    }
    
    setStateUpdate(crew,activity,status,errorData,emailUpdated,crewProfileStatus,crewProfileActivity){
        let formErrors = this.state.formErrors; 
        let arrTmp = crewProfileActivity.split('~~'); 
        if(arrTmp[0]===types.CREW_BASIC_INFO_ADD_SUCCESS){  
            if(this.state.crewData.basicInfo.chkSendVerifyEmail) this.setToasterState(true,MSG_CREW_INFO_SAVE,true,false); 
            else this.setToasterState(true,MSG_CREW_INFO_SAVE_NO_EMAIL,true,false); 
            this.setState({crewId:crew.id}, () => {
                this.props.crewEditAction(crew.id);    
            });
            this.props.callCrewListAction(); 
        }else if(arrTmp[0]===types.CREW_BASIC_INFO_ADD_ERROR){ 
            if(crewProfileStatus===400){
                if(errorData.hasOwnProperty('email')){
                    formErrors.emailAddress = errorData.email[0];
                }else{
                    this.setToasterState(true,MSG_DATA_SAVE_ERROR,false); // JSON.stringify(errorData)
                    console.log(errorData); 
                }                       
                this.setState(formErrors);
            }else{
                if(errorData.hasOwnProperty('message')){ 
                    this.setToasterState(true,errorData.message,false);
                }else{
                    this.setToasterState(true,MSG_DATA_SAVE_ERROR,false); // JSON.stringify(errorData)
                    console.log(errorData); 
                }
            }
        }else if(arrTmp[0]===types.CREW_BASIC_INFO_UPDATE_SUCCESS){
            if(emailUpdated){
                this.setToasterState(true,MSG_CREW_INFO_EMAIL_UPDATE,true,false);  
            }else{
                this.setToasterState(true,MSG_CREW_INFO_UPDATE,true);  
            }
            if(this.state.crewId) {
                this.props.validateCrewDetailsAction(this.state.crewId); 
                let crewData         = this.state.crewData;
                crewData.basicInfo.isInducted_server = crewData.basicInfo.isInducted;
                crewData.basicInfo.isApproved_server = crewData.basicInfo.isApproved;
                this.setState({crewData});
            }
            this.props.callCrewListAction(); 
        }else if(arrTmp[0]===types.CREW_BASIC_INFO_UPDATE_ERROR){ 
            if(crewProfileStatus===400){
                if(errorData.hasOwnProperty('email')){
                    formErrors.emailAddress = errorData.email[0];
                }else{
                    this.setToasterState(true,MSG_DATA_SAVE_ERROR,false); // JSON.stringify(errorData)
                    console.log(errorData); 
                }                       
                this.setState(formErrors);
            }else{
                if(errorData.hasOwnProperty('message')){ 
                    this.setToasterState(true,errorData.message,false);
                }else{
                    this.setToasterState(true,MSG_DATA_SAVE_ERROR,false); // JSON.stringify(errorData)
                    console.log(errorData); 
                }
            }                            
        } else if(arrTmp[0]===types.CREW_ACTIVE_DEACTIVE_SUCCESS){
            //let msgStr = this.state.activeDeactiveText===LBL_ACTIVATE ? (LBL_CREW+" "+this.state.crewData.basicInfo.firstName+' '+this.state.crewData.basicInfo.lastName+" "+MSG_CREW_ACTIVATED) : this.state.activeDeactiveText===LBL_DEACTIVATE ? (LBL_CREW+" "+this.state.crewData.basicInfo.firstName+' '+this.state.crewData.basicInfo.lastName+" "+MSG_CREW_DELETED) : MSG_STATUS_UPDATED; 
            // this.props.history.push({
            //     pathname:ROUTE_AFFILIATE_CREW,
            //     state:{ toastMessageStr:msgStr }
            // });

            let msgStr = this.state.activeDeactiveText===LBL_ACTIVATE ? (LBL_CREW+" "+this.state.crewData.basicInfo.firstName+' '+this.state.crewData.basicInfo.lastName+" "+MSG_CREW_ACTIVATED) : this.state.activeDeactiveText===LBL_DEACTIVATE ? MSG_CREW_DEACTIVATED : MSG_STATUS_UPDATED; 
            if(this.state.activeDeactiveText===LBL_ACTIVATE) {
                let nextNum = Number(this.state.crewActivatedSuccess)+1;
                this.setState({crewActivatedSuccess:nextNum}); 
            }
            else {
                let nextNum = Number(this.state.crewDeactivatedSuccess)+1;
                this.setState({crewDeactivatedSuccess:nextNum}); 
            }

            this.setToasterState(true,msgStr,true); 
            if(this.state.crewId) {
                this.props.validateCrewDetailsAction(this.state.crewId); 
                this.props.crewEditAction(this.state.crewId); 
            }
            this.props.callCrewListAction(); 
            this.props.onCloseSlider();
        }else if(arrTmp[0]===types.CREW_ACTIVE_DEACTIVE_ERROR){
            // this.setToasterState(true,JSON.stringify(errorData),false);
            this.setToasterState(true,MSG_DATA_SAVE_ERROR,false); // JSON.stringify(errorData)
            console.log(errorData)
        }else if(arrTmp[0]===types.CREW_APPROVE_SUCCESS){ 
            this.modalCrewApprove.current.handleModelCloseOnly();
            let crewData   = this.state.crewData;     
            let basicInfo  = this.state.crewData.basicInfo;
            basicInfo['isApproved'] = crew.isApproved;
            this.setState({crewData}); 
            let message = 'You have approved '+basicInfo.firstName +' '+basicInfo.lastName+' as a Crew member successfully.';            
            this.setToasterState(true,message,true);
            if(this.state.crewId) {
                this.props.validateCrewDetailsAction(this.state.crewId); 
                this.props.crewEditAction(this.state.crewId); 
            }
            this.props.callCrewListAction(); 
        }else if(arrTmp[0]===types.CREW_APPROVE_ERROR){
            if(crewProfileStatus===405){
                if(errorData.hasOwnProperty('message')){
                    let errString = errorData.message;
                    if(errString==='not_inducted'){
                        this.setToasterState(true,MSG_CREW_APPROVE_ERROR,false);
                    }
                }
            }
        }else if(arrTmp[0]===types.CREW_AVAILABILITY_SUCCESS){
            let message = '';
            if(crew.availabilityStatus){
                message = MSG_AVAILABILITY_STATUS+' active';
            }else{
                message = MSG_AVAILABILITY_STATUS+' inactive';
            }
            this.setToasterState(true,message,true);
            if(this.state.crewId) {
                this.props.validateCrewDetailsAction(this.state.crewId); 
                this.props.crewEditAction(this.state.crewId); 
            }
            this.props.callCrewListAction(); 
        }else if(arrTmp[0]===types.CREW_AVAILABILITY_ERROR){
            if(errorData.crew_not_approved){ 
                this.setToasterState(true,MSG_CREW_AVAILABILITY_ERROR,false);
            }else{
                // this.setToasterState(true,JSON.stringify(errorData.message),false);
                this.setToasterState(true,MSG_DATA_SAVE_ERROR,false);  
                console.log(errorData.message); 
            }
            this.setState({ 
                availabilityStatus: false 
            });   
        }else if(arrTmp[0]===types.RESEND_EMAIL_SUCCESS){
            this.setToasterState(true,MSG_MAIL_RESEND,true,false);
        }else if(arrTmp[0]===types.RESEND_EMAIL_ERROR){
            this.setToasterState(true,MSG_MAIL_RESEND_ERROR,false);
        }else if(arrTmp[0]===types.CREW_CHIEF_APPROVE_SUCCESS){
            this.modalCrewChiefEligible.current.handleModelCloseOnly();
            const {basicInfo} = this.state.crewData;            
            let message = '';
            let userGroupData = userGroupUrlCheck(window.location);
            let supervisor_name = '';
            if(userGroupData!==undefined){
                supervisor_name = userGroupData.supervisor_name; 
            }
            if(crew.chiefEligibility){
                message = "You have set crew '"+basicInfo.firstName+' '+basicInfo.lastName+"' as eligible for "+supervisor_name+".";
            }else{
                message = "You have set crew '"+basicInfo.firstName+' '+basicInfo.lastName+"' as ineligible for "+supervisor_name+".";
            }
            this.setToasterState(true,message,true);
            if(this.state.crewId) {
                this.props.crewEditAction(this.state.crewId); 
            }
            this.props.callCrewListAction(); 
        } else if(arrTmp[0]===types.CREW_CHIEF_APPROVE_ERROR){ 
            this.setToasterState(true,MSG_CREW_CHIEF_APPROVE_ERROR,false);
        } 
        else if(arrTmp[0]===types.CREW_INDUCTION_SUCCESS){ 
            this.modalCrewInduction.current.handleModelCloseOnly();
            let crewData   = this.state.crewData;     
            let basicInfo  = this.state.crewData.basicInfo;
            basicInfo['isInducted'] = crew.isInducted;
            this.setState({crewData}); 
            let message = basicInfo.firstName +" "+basicInfo.lastName+"'s induction completed.";            
            this.setToasterState(true,message,true);
            if(this.state.crewId) {
                this.props.validateCrewDetailsAction(this.state.crewId); 
                this.props.crewEditAction(this.state.crewId); 
            }
        } 
        else if(arrTmp[0]===types.CREW_INDUCTION_ERROR){ 
            this.setToasterState(true,MSG_CREW_INDUCTION_ERROR,false);
        }        
    }

    componentDidUpdate(prevProps) {
        const { crew, status,activity,errorData, dynFieldsStatus, dynFieldsActivity, countryListStatus, countryListActivity, emailUpdated, timezonesListStatus, timezonesListActivity, payLevelList, payLevelStatus, payLevelActivity,  validateResponse, validateStatus, validateActivity, validateErrorData, activeCrewId, crewProfileStatus, crewProfileActivity, addNewButtonClicked } = this.props; 

        if(addNewButtonClicked && Number(addNewButtonClicked) > Number(this.state.addNewButtonClicked)) {
            this.resetStateOnCrewAdd(activeCrewId,addNewButtonClicked); 
            this.props.validateCrewAddAction(); // TO VALIDATE MANDATORY DATA ADDED BEFORE CREATING CREW
        }

        if(activeCrewId && Number(activeCrewId) > 0 && (this.state.crewId!==activeCrewId || !this.state.editCreDetailsCalled)) {
            this.setState({crewId:activeCrewId,editCreDetailsCalled:true}, () => {
                this.resetStateOnCrewAdd(activeCrewId,this.state.addNewButtonClicked); 
                this.props.validateCrewDetailsAction(this.state.crewId); 
                this.props.crewEditAction(activeCrewId); 
            })
        }

        if (validateActivity && (validateStatus !== prevProps.validateStatus || validateActivity!==prevProps.validateActivity)) {
            var arrTemp = validateActivity.split('~~'); 
            if(arrTemp[0]===types.VALIDATE_CREW_ADD_SUCCESS || arrTemp[0]===types.VALIDATE_CREW_DETAILS_SUCCESS) {
                if(validateStatus===200) {
                    this.setState({validationMsgArr:[]});
                }
                else if(validateStatus!==200) {
                    if(validateResponse.mandatories && Array.isArray(validateResponse.mandatories)) {
                        this.setState({validationMsgArr:validateResponse.mandatories});
                    }
                    else {
                        this.setState({validationMsgArr:['common_error']});
                    }
                } // validateErrorData
            }
        }


        if (crewProfileActivity && crewProfileActivity !== prevProps.crewProfileActivity) {
            var arrTmp = crewProfileActivity.split('~~'); 

            if(arrTmp[0]===types.DEPARTMENT_LIST_AFFILIATE_SUCCESS){
                if(this.props.hasOwnProperty('afltDepartmentsForCrew')) {
                    if(this.props.afltDepartmentsForCrew.length===0) {
                          this.setState({departmentsList: []}, () => {
                             this.loadMultiSelDeptValues(); 
                          } ); 
                    }
                    else {     
                          this.setState({departmentsList: this.props.afltDepartmentsForCrew}, () => {
                             this.loadMultiSelDeptValues(); 
                          } );                  
                    }
                }
            }

            if(arrTmp[0]===types.CREW_EDIT_SUCCESS){ 
                this.callDymanicFieldsMasters(); 
                let crewDepts = [];
                if(Array.isArray(crew.department)) crewDepts = crew.department;  
                let allDept = []; 
                if(this.state.departmentsList.length > 0) {
                    this.state.departmentsList.forEach((item,index) => { 
                        if(crewDepts.includes(item.id)) allDept.push({value:item.id, label:titleCase(item.name), inputVal: item.id}); 
                        else allDept.push({value:item.id, label:titleCase(item.name)}); 
                    } ) 
                }

                let act_tab = "company-info-tab";

                if(this.props.calledFrom && this.props.calledFrom==='certificates'){
                    act_tab = 'documents-tab';
                }
                else if(this.state.crewData.activeTab.startsWith('company-Dynamic')){
                    act_tab = this.state.crewData.activeTab;
                }

                this.setState({
                    deptMultiSelList:allDept,
                    crewData:{
                        basicInfo:{
                            id: (crew.id) ? crew.id : '',
                            firstName: (crew.firstName) ? crew.firstName : '',
                            lastName:(crew.lastName) ? crew.lastName : '',
                            preferedName:(crew.preferedName) ? crew.preferedName : '',
                            contactNumber:(crew.contactNumber) ? crew.contactNumber : '',
                            emailAddress:(crew.emailAddress) ? crew.emailAddress : '', 
                            alternateContactNum:(crew.alternateContactNum) ? crew.alternateContactNum : '',
                            gender:(crew.gender) ? crew.gender : '',
                            dob:crew.dob===null?'':crew.dob + " 00:00:00",
                            nationality:(crew.nationality) ? crew.nationality : '',
                            department:crewDepts,
                            googleLocation:(crew.googleLocation) ? crew.googleLocation : '',
                            venue:(crew.venue) ? crew.venue : '',
                            streetOne:(crew.streetOne) ? crew.streetOne : '',
                            streetTwo:(crew.streetTwo) ? crew.streetTwo : '',
                            city:(crew.city) ? crew.city : '',
                            state:(crew.state) ? crew.state : '',
                            country:(crew.country) ? crew.country : '',
                            postcode:(crew.postcode) ? crew.postcode : '',
                            passport:(crew.passport) ? crew.passport : '',
                            visa:(crew.visa) ? crew.visa : '',
                            additionalText:(crew.additionalText) ? crew.additionalText : '',
                            affiliateId:crew.affiliateId===null?'':crew.affiliateId,
                            logo:'',
                            emailVerify:crew.emailVerify===null?'':crew.emailVerify,
                            userId:crew.userId===null?'':crew.userId,
                            timeZone:(crew.timeZone)?crew.timeZone:null,
                            crewStarRatings: crew.crewStarRatings,
                            isInducted:crew.isInducted,
                            isInducted_server:crew.isInducted, // TO DISABLE EDITING
                            isApproved:crew.isApproved===null?'':crew.isApproved,
                            isApproved_server:crew.isApproved===null?'':crew.isApproved,  // TO DISABLE EDITING
                            payLevel:crew.payLevel,
                            affiliate_relation_status:crew.affiliate_relation_status,
                            has_vehicle:crew.has_vehicle
                        },                    
                        activeTab: act_tab                    
                    },            
                    lastlogin:crew.lastlogin,
                    ppPoints:crew.ppPoints,
                    omnuPoints:crew.omnuPoints,
                    availabilityStatus:crew.availabilityStatus,
                    chiefEligibility:crew.chiefEligibility,
                    driveToShiftLocation:crew.driveToShiftLocation,
                    imgUrl:crew.logo,                
                    crewId:crew.id,
                    dynamicFieldsSavedData:crew.dynamic_fields,
                    formErrors:{
                        firstName: '',
                        lastName: '',
                        preferedName: '',
                        contactNumber: '',
                        emailAddress: '',
                        gender: '',
                        streetOne:'',
                        streetTwo:'',
                        city:'',
                        state:'',
                        country:'',
                        postcode:'', 
                        nationality: '',
                        timeZone: '', 
                        payLevel: '',
                        department: '',  
                        locationName: '', 
                    },        
                }, () => {
                    this.onTabChange('', act_tab); // SHOW BASIC INFO TAB
                }); 
                if(this.state.crewId) this.props.validateCrewDetailsAction(this.state.crewId); 
                 
            }else if(arrTmp[0]===types.CREW_EDIT_ERROR){
                this.callDymanicFieldsMasters(); 
                if(status===404){
                    // this.props.history.push(ROUTE_AFFILIATE_CREW) 
                }
            }
        }

        if (payLevelActivity && payLevelActivity !== prevProps.payLevelActivity) { 
            let arrPLResp = payLevelActivity.split('~~'); 
            let plString = arrPLResp[0];
            if(plString===types.PAY_LEVELS_LIST_SUCCESS) { // to set pay level mandatory IF ONLY ONE PAYLEVEL IS THERE 
                if(payLevelList && Array.isArray(payLevelList) && payLevelList.length==1 && payLevelList[0]?.id > 0 && payLevelList[0]?.is_active==true){
                    let crData = this.state.crewData; 
                    let frmErrors = this.state.formErrors; 
                    crData.basicInfo.payLevel = payLevelList[0].id; 
                    frmErrors.payLevel = ''; 
                    this.setState({crewData:crData,formErrors:frmErrors,defaultPaylevelId:payLevelList[0].id});
                }
            }
        }

        if ((activity && activity !== prevProps.activity) || (crewProfileActivity && crewProfileActivity !== prevProps.crewProfileActivity)) {
            this.setStateUpdate(crew,activity,status,errorData,emailUpdated,crewProfileStatus,crewProfileActivity);
            this.props.clearAction();

            let arrResp = activity.split('~~'); 
            let actString = arrResp[0]; 

            if(actString===types.DEPARTMENT_LIST_AFFILIATE_SUCCESS){
                if(this.props.hasOwnProperty('afltDepartmentsForCrew')) {
                    if(this.props.afltDepartmentsForCrew.length===0) {
                          this.setState({departmentsList: []}, () => {
                             this.loadMultiSelDeptValues(); 
                          } ); 
                    }
                    else {     
                          this.setState({departmentsList: this.props.afltDepartmentsForCrew}, () => {
                             this.loadMultiSelDeptValues(); 
                          } );                  
                    }
                }
            }
        }

        if ((countryListActivity) && countryListActivity !== prevProps.countryListActivity) {
            let arrResp = countryListActivity.split('~~'); 
            let actString = arrResp[0];
            if(countryListStatus===200 && actString===types.COUNTRY_LIST_SUCCESS) {
                let cn = this.props.countryList;
                let newCN = cn.filter(item => item.nationality.trim().toLowerCase()===DEFAULT_COUNTRY_NAME.trim().toLowerCase() && item.country_iso_code.trim().toLowerCase()===DEFAULT_COUNTRY_CODE.trim().toLowerCase()); 
                let defCNId = 0 ;
                if(newCN.length) defCNId = newCN[0].id;
                let crewData = this.state.crewData;    
                if(!crewData.basicInfo.nationality) crewData.basicInfo.nationality = defCNId;
                this.setState({crewData:crewData,arrCountryList:this.props.countryList,defaultNationality:defCNId}); 
            }
            else {
            }
        }


        // CHECKING DYNAMIC FIELDS DATA LISTING 
        if (dynFieldsActivity && (dynFieldsStatus !== prevProps.dynFieldsStatus || dynFieldsActivity!==prevProps.dynFieldsActivity)) {
            let arrResp = dynFieldsActivity.split('~~'); 
            let actString = arrResp[0]; 
            
            // types.DYNAMIC_FIELDS_LIST_SUCCESS, types.DYNAMIC_FIELDS_LIST_ERROR
            if(actString===types.DYNAMIC_FIELDS_LIST_SUCCESS) {  
                if(this.props.hasOwnProperty('dynFieldsAllItems')) {
                    if(this.props.dynFieldsAllItems.length===0) {
                        this.setState({dynFieldsAllItems: []}); 
                    }
                    else {                      
                        let tmpObj = {};
                        let fieldsObj = {};
                        let allPagesObj = []; 
                        this.props.dynFieldsAllItems.forEach((rObj) => { 
                            if(!Array.isArray(rObj.field_details)) rObj.field_details = []; // IF OBJECT {} RETURNED, CONVERT TO ARRAY 
                            if(rObj.show_tab && rObj.field_details.length > 0) {
                                fieldsObj =  rObj.field_details; 
                                let iconName = ''; 
                                if(!rObj.icon_name || rObj.icon_name===null || rObj.icon_name.trim().length===0) {
                                    let filterObj = {pageName:'', iconName:''}; 
                                    filterObj = DYNAMIC_PAGE_ICONS.filter(pageDet => pageDet.pageName.trim().toLowerCase()===rObj.name.trim().toLowerCase()); // DEFINED IN staticConfigs.js
                                    if(filterObj.length) iconName = filterObj[0].iconName; 
                                    
                                }
                                else {
                                    iconName = rObj.icon_name; 
                                }

                                tmpObj = {
                                    id:rObj.id, name:rObj.name, field_details:fieldsObj, show_tab:rObj.show_tab, icon_name:iconName, user_type:rObj.user_type
                                };

                                allPagesObj.push(tmpObj);
                            }
                            
                        });
                        this.setState({dynFieldsAllItems: allPagesObj}); 
                    }
                } 
                else { 
                    this.setState({dynFieldsAllItems: []}); 
                }
            }  
            else if(actString===types.DYNAMIC_FIELDS_LIST_ERROR) { 
                this.setState({toastSuccess:false, toastFlag:true, toastMessage:MSG_ERROR});
                setTimeout(()=> {
                    this.onCloseToast(); 
                }, 3000);
            } 
            else if(actString===types.DYNAMIC_FIELDS_DATA_SAVE_SUCCESS) { 
                this.setState({toastSuccess:true, toastFlag:true, toastMessage:MSG_DYNAMIC_FIELD_DATA_SAVE_SUCCESS});
                setTimeout(()=> {
                    this.onCloseToast(); 
                }, 3000);
                if(this.state.crewId) this.props.validateCrewDetailsAction(this.state.crewId); 
                this.props.callCrewListAction();
                this.props.crewEditAction(crew.id);

            } 
            else if(actString===types.DYNAMIC_FIELDS_DATA_SAVE_ERROR) { 
                this.setState({toastSuccess:false, toastFlag:true, toastMessage:MSG_DYNAMIC_FIELD_DATA_SAVE_ERROR});
                setTimeout(()=> {
                    this.onCloseToast(); 
                }, 4000);
            }
        }

        if (timezonesListActivity && (timezonesListStatus !== prevProps.timezonesListStatus || timezonesListActivity!==prevProps.timezonesListActivity)) {
            let arrResp = (timezonesListActivity) ? timezonesListActivity.split('~~') : []; 
            let actString = arrResp[0]; 
            if(actString===types.TIMEZONES_LIST_SUCCESS) { 
                if(timezonesListStatus===200) {
                    let tz = this.props.timeZonesAllItems;
                    let newTZ = tz.filter(item => item.region.trim().toLowerCase()===DEFAULT_TIME_ZONE.trim().toLowerCase()); 
                    let defTZId = 0 ;
                    if(newTZ.length) defTZId = newTZ[0].id;
                    let crewData = this.state.crewData;   
                    if(!crewData.basicInfo.timeZone) crewData.basicInfo.timeZone = defTZId;
                    this.setState({crewData:crewData,defaultTimeZoneId:defTZId,timeZonesList:this.props.timeZonesAllItems}) 
                }
                else {
                    // timezonesListErrorData
                    this.setState({toastSuccess:false, toastFlag:true, toastMessage:MSG_TIMEZONE_DATA_ERROR});
                    setTimeout(()=> { this.onCloseToast(); }, 5000);
                }
            } 
            else if(actString===types.TIMEZONES_LIST_ERROR) { 
                // timezonesListErrorData
                this.setState({toastSuccess:false, toastFlag:true, toastMessage:MSG_TIMEZONE_DATA_ERROR});
                setTimeout(()=> { this.onCloseToast(); }, 5000);
            }
        } 
    }

    callDymanicFieldsMasters = () => {
        const { location } = this.props;
        let userGroupData = userGroupUrlCheck(window.location);
        let userGroup = ''; 
        if(userGroupData!==undefined){
            userGroup = userGroupData.user_group; 
        }

        let listDynData = {groupId: LOGIN_CREW_GROUP, reqFrom:userGroup}; 
        this.setState({listDynData:listDynData}, () => { 
            this.props.dynamicFieldsListAction(listDynData);
        });
    }

    componentDidMount() {
        this.props.aflt_departmentsListAction({associated:'1'});
        this.props.payLevelsListAction();   
        if(this.state.timeZonesList.length===0) {
            this.props.timeZonesListAction(); 
        }
        this.props.countryListAction();
        const { location } = window.location;
        let userGroupData = userGroupUrlCheck(window.location);
        let userGroup = '';
        if(userGroupData!==undefined){
            userGroup = userGroupData.user_group; 
        }

        // if(this.state.crewId!==undefined){
        //     const crewId = this.state.crewId; 
        //     this.props.crewEditAction(crewId);   
        //     this.props.validateCrewDetailsAction(crewId); // TO VALIDATE MANDATORY DATA ADDED WHILE EDIT CREW
        //     document.title = LBL_APP_NAME+" - "+LBL_CREW_EDIT; 
        // }
        // else {
        //     this.props.validateCrewAddAction(); // TO VALIDATE MANDATORY DATA ADDED BEFORE CREATING CREW
        //     document.title = LBL_APP_NAME+" - "+LBL_CREW_ADD;
        // }

          
        
        if(userGroup===LOGIN_AFFILIATE_GROUP){
            document.body.classList.add('body-affiliate');
        }
    } 

    render(){
      
        const { status,payLevelList} = this.props;
        const { toastMessage,toastFlag,toastSuccess,crewId,chiefEligibility} = this.state;        
        let isCrewUnavailabilityView = checkPermissions("crewunavailability","view");
        let userGroupData = userGroupUrlCheck(window.location);
        let userGroup = '';
        let lbl_crew_chief = '';
        let lbl_crew_chief_no = '';  
        let supervisor_name = '';
        let lbl_supervisor_eligible = '';
          
        if(userGroupData!==undefined){
            userGroup = userGroupData.user_group;
            supervisor_name = userGroupData.supervisor_name; 
            lbl_crew_chief = stringFormat(LBL_VERIFY_CREW_CHIEF_Q,userGroupData.supervisor_name); 
            lbl_crew_chief_no = stringFormat(LBL_VERIFY_CREW_CHIEF_NO_Q,userGroupData.supervisor_name);
            lbl_supervisor_eligible = supervisor_name+' Eligible' 
        }
        if(!lbl_crew_chief){
            lbl_crew_chief = stringFormat(LBL_VERIFY_CREW_CHIEF_Q,'Chief'); 
            lbl_crew_chief_no = stringFormat(LBL_VERIFY_CREW_CHIEF_NO_Q,'Chief');
        }
        
        if(status===401 || status===403){
            if(userGroup===LOGIN_AFFILIATE_GROUP){
                return <Redirect to={ROUTE_AFFILIATE_REFRESH} />;
            }else{
                return <Redirect to={ROUTE_REFRESH} />;

            }
        }      

        let crewFullName = LBL_CREW_ADD;  
        let SepVal = ''; 
        if(this.state.crewData.basicInfo.firstName) {
            crewFullName = this.state.crewData.basicInfo.firstName;
            SepVal = ' '; 
        }
        if(this.state.crewData.basicInfo.lastName) crewFullName += SepVal+this.state.crewData.basicInfo.lastName;
        
        let confirmMsg = 'not';
        if(chiefEligibility){
            confirmMsg = '';
        }
        
        let validationMsgStr = ''; 
        if(this.state.validationMsgArr.length) {
            if(!crewId) { // CREW ADD VALIDATION 
                this.state.validationMsgArr.forEach(item => {
                    validationMsgStr += validationMsgCrewAdd[item] ? validationMsgCrewAdd[item]+'' : '';
                }); 
                //EXCEPTION HANDLING 
                if(validationMsgStr==='') validationMsgStr = validationMsgCrewAdd['common_error'];
                else validationMsgStr = validationMsgCrewAdd['common_header']+validationMsgStr;  
            }
            else {
                this.state.validationMsgArr.forEach(item => {
                    if(item.documents) {
                        validationMsgStr += validationMsgCrewDetails['documents_START']+item.documents.join(', ')+validationMsgCrewDetails['documents_END']; 
                    }else if(item.skill_documents){
                        validationMsgStr += validationMsgCrewDetails['skill_documents_START']+item.skill_documents.join(', ')+validationMsgCrewDetails['skill_documents_END'];
                    } 
                    else validationMsgStr += validationMsgCrewDetails[item] ? validationMsgCrewDetails[item]+'' : '';
                }); 
                
                //EXCEPTION HANDLING 
                if(validationMsgStr==='') validationMsgStr = validationMsgCrewDetails['common_error'];
                else validationMsgStr = validationMsgCrewDetails['common_header']+validationMsgStr;  
            }
        }

        let default_event_key = 'company-info-tab';
        if(this.props.fromExpiryCertificatesWindow){
            default_event_key = 'documents-tab';
            this.props.fromExpiryCertificates(false);
        }
        return(

            <React.Fragment>
                <Toast toastDescription={toastMessage} toastFlag={toastFlag} toastSuccess={toastSuccess} closeToast={this.onCloseToast} />
                <div className="detail-head border-bottom pb-2 padding-top-7">
                    <h6>{crewFullName}
                    <button className="close-filter text-muted" onClick={this.onHideFilterBy}>
                        <span aria-hidden="true">×</span>
                    </button>
                    </h6>
                </div>
                <div className="row">
                    {validationMsgStr.length > 0 && <div className="text-validation"><small>{ReactHtmlParser(validationMsgStr)}</small></div>}
                </div>
                
                <Scrollbars style={{ height: '100vh' }}  autoHide renderThumbVertical={this.renderThumb} >

                    <div className="filter-content ">
                        <Tab.Container  id="quote-details-tab" activeKey={this.state.crewData.activeTab} >
                            <Nav variant="pills" className='margin-left-9'>
                                {/* <i className="las la-user-plus"></i> <i className="las la-tags"></i> <i className="las la-user-alt-slash"></i> <i className="las la-file-alt"></i> <i className={item.icon_name}></i> */}
                                <Nav.Item className="profile-tab-pills" > 
                                    <Nav.Link eventKey={"company-info-tab"} onClick={(e) => this.onTabChange(e, "company-info-tab")}  ><small> {LBL_BASIC_INFO}</small></Nav.Link>
                                </Nav.Item>

                                <Nav.Item>
                                    <Nav.Link className={crewId===undefined?'disabled':''} eventKey={"skills-tab"} onClick={(e) => this.onTabChange(e, "skills-tab")} ><small> {LBL_SKILLS}</small></Nav.Link>
                                </Nav.Item> 
                              
                                {isCrewUnavailabilityView && <Nav.Item>
                                    <Nav.Link className={crewId===undefined?'disabled':''} eventKey={"unavailability-tab"} onClick={(e) => this.onTabChange(e, "unavailability-tab")} ><small> {LBL_UNAVAILABILITY}</small></Nav.Link>
                                </Nav.Item>}

                                <Nav.Item>
                                    <Nav.Link className={crewId===undefined?'disabled':''} eventKey={"documents-tab"} onClick={(e) => this.onTabChange(e, "documents-tab")} ><small>{LBL_DOCUMENTS}</small></Nav.Link>
                                </Nav.Item>
                                
                                {this.state.hasOwnProperty('dynFieldsAllItems') && this.state.dynFieldsAllItems.map((item,index) => { 
                                    // if(STR_VEHICLE_INFO.toLowerCase()==item.name.toLowerCase()) {
                                    //     return null; 
                                    // }
                                    // else { }
                                        return ( <Nav.Item key={"company-Dynamic-ItemTab_"+index}>
                                            <Nav.Link className={crewId===undefined?' disabled':''} eventKey={"company-Dynamic-tab_"+index} onClick={(e) => this.onTabChange(e, "company-Dynamic-tab_"+index)} ><small>{item.name}</small></Nav.Link>
                                            </Nav.Item>
                                        )
                                   
                                } ) } 

                                <Nav.Item>
                                    <Nav.Link className={crewId===undefined?'disabled':''} eventKey={"crew-notes-tab"} onClick={(e) => this.onTabChange(e, "crew-notes-tab")} ><small>{LBL_NOTES}</small></Nav.Link>
                                </Nav.Item>

                                {/* <Nav.Item>
                                    <Nav.Link className={crewId===undefined?'disabled':''} eventKey={"crew-vehicle-info-tab"} onClick={(e) => this.onTabChange(e, "crew-vehicle-info-tab")} ><small>{LBL_VEHICLE_INFO}</small></Nav.Link>
                                </Nav.Item> */}

                                <Nav.Item>
                                    <Nav.Link className={crewId===undefined?'disabled':''} eventKey={"timesheet-tab"} onClick={(e) => this.onTabChange(e, "timesheet-tab")} ><small>{LBL_TIMESHEET}</small></Nav.Link>
                                </Nav.Item>

                                <Nav.Item>
                                    <Nav.Link className={crewId===undefined?'disabled':''} eventKey={"feedback-tab"} onClick={(e) => this.onTabChange(e, "feedback-tab")} ><small>{LBL_FEEDBACK}</small></Nav.Link>
                                </Nav.Item>
                            </Nav>  

                            <Tab.Content>    
                                <Tab.Pane eventKey="company-info-tab">
                                    <BasicInfo  showNameInHeader={crewFullName} deptMultiSelList={this.state.deptMultiSelList} saveFormData={(e) => this.saveFormData(e, "company-info-tab")} onHandleChange={(e) => this.onHandleChange(e, "company-info-tab")} deleteCrew={(e) => this.deleteCrew(e)} activateCrew={(e) => this.activateCrew(e)} onAvailabilityChange={(e) => this.onAvailabilityChange(e)}  onDriveToShiftLocationChange={(e) => this.onDriveToShiftLocationChange(e)} onDateChange={this.onDateChange} onPhoneInputChange={this.onPhoneInputChange} onAlternatePhoneInputChange={this.onAlternatePhoneInputChange} onApproveCrew={(e) => this.approveCrewModalOpen(e)} resendEmail={(e) => this.resendEmail(e)} onChiefEligibility={(e) => this.chiefEligibleModalOpen(e)} {...this.state}  onGetGoogleLoc={(e) => this.onGetGoogleLoc(e)} googleLocSelect={(e) => this.googleLocSelect(e)} countryFieldName={'nationality'} countryListClass='' arrCountryList={this.props.countryList} handleChangeMultiSel={this.handleChangeMultiSel} onInductionCrew={(e) => this.inductionCrewModalOpen(e)} payLevelList={payLevelList} supervisor_name={supervisor_name} crewActivatedSuccess={this.state.crewActivatedSuccess} crewDeactivatedSuccess={this.state.crewDeactivatedSuccess} defaultTimeZoneId={this.state.defaultTimeZoneId} resetGoogleLocation={this.props.resetGoogleLocation} />
                                </Tab.Pane> 
                            
                                <Tab.Pane eventKey="skills-tab">
                                { (crewId!==undefined) &&
                                <Skills showNameInHeader={crewFullName} setToasterState={this.setToasterState} {...this.state} reloadParentCrewList={this.reloadParentCrewList}
                                />
                                }
                                </Tab.Pane>  

                                <Tab.Pane eventKey="unavailability-tab">
                                { (crewId!==undefined) &&
                                <Unavailability showNameInHeader={crewFullName} setToasterState={this.setToasterState} {...this.state} location={window.location}
                                />
                                }
                                </Tab.Pane> 
                            
                                <Tab.Pane eventKey="documents-tab">
                                { (crewId!==undefined) && 
                                    <Documents {...this.state} showNameInHeader={crewFullName}  callparentValidate='yes' callValidate={this.callValidate} noHeaderName="yes" 
                                    calledFrom={this.props.calledFrom?this.props.calledFrom:''} callCertificateListAction={this.callCertificateListAction}  />  
                                }                         
                                </Tab.Pane>  
                             
                                {this.state.hasOwnProperty('dynFieldsAllItems') && this.state.dynFieldsAllItems.map((item,index) => { 
                                    return(<Tab.Pane eventKey={"company-Dynamic-tab_"+index} key={index} >
                                        <DynamicFieldsDetails  showNameInHeader={crewFullName}  dynamicFieldsDataSaveAction={(e) => this.props.dynamicFieldsDataSaveAction(e)} 
                                        {...this.state} headerText={item.name} dynFieldsActiveItem={item} dynamicFieldsFor={LOGIN_CREW_GROUP} noHeaderName="yes" />  
                                    </Tab.Pane>
                                    ); 
                                } ) }

                                <Tab.Pane eventKey="crew-notes-tab">
                                { (crewId!==undefined) && 
                                    <CrewNotes crewId={this.state.crewId} affiliateId={this.state.affiliateId} associateId={this.state.associateId} loadCrewNotes={this.state.loadCrewNotes} /> 
                                }                         
                                </Tab.Pane> 

                                <Tab.Pane eventKey="timesheet-tab">
                                { (crewId!==undefined) && 
                                    <CrewTimesheet crewId={this.state.timesheetCrewId} />  
                                }                         
                                </Tab.Pane> 

                                <Tab.Pane eventKey="feedback-tab">
                                { (crewId!==undefined) && 
                                    <CrewFeedback crewId={this.state.feedbackCrewId} /> 
                                }                         
                                </Tab.Pane>
                                <Tab.Pane eventKey="crew-vehicle-info-tab">
                                { (crewId!==undefined) && 
                                    <CrewVehicleInfo crewId={this.state.crewId} reloadParentCrewList={this.reloadParentCrewList}/> 
                                }                         
                                </Tab.Pane> 

                            </Tab.Content>
                        
                        </Tab.Container>  

                    </div>
                </Scrollbars>
            

                <ModalWindow ref={this.modalCrewInduction} header="Crew Induction" type="confirm" deleteConfirmedItem={this.onInductionCrew} resetModalForm={this.onModalFormResetInduction} >
                    {LBL_CREW_INDUCTION_COMPLETED_Q}
                </ModalWindow>  
                <ModalWindow ref={this.modalCrewApprove} header="Crew Approve" type="confirm" deleteConfirmedItem={this.onApproveCrew} resetModalForm={this.onModalFormResetApproval} >
                    {LBL_VERIFY_CREW_DOCUMENTS_Q}
                </ModalWindow>  
                <ModalWindow ref={this.modalCrewChiefEligible} header={lbl_supervisor_eligible} type="confirm" deleteConfirmedItem={this.onChiefEligibility} resetModalForm={this.onModalFormReset} >
                        {confirmMsg.length > 1 ? lbl_crew_chief_no : lbl_crew_chief}
                </ModalWindow>
                <ModalWindow ref={this.logoModalCropper} type="imageCropper" saveFormData={ (e)=>this.cropImage(e)}>
                    <Cropper
                        image={this.state.imgUrl}
                        crop={this.state.crop}
                        zoom={this.state.zoom}
                        aspect={this.state.aspect}
                        onCropChange={this.onCropChange}
                        onCropComplete={this.onCropComplete}
                        onZoomChange={this.onZoomChange}
                      />
                </ModalWindow>           
            </React.Fragment>
        )
    }

}
const mapStateToProps = (state) => {
    return {
        crew:state.crews.item,
        status:state.crews.status,
        activity:state.crews.activity,
        crewProfileStatus:state.crews.crewProfileStatus,
        crewProfileActivity:state.crews.crewProfileActivity,
        afltDepartmentsForCrew:state.crews.afltDepartmentsForCrew,
        errorData:state.crews.errorData,
        dynFieldsStatus:state.dynamicFields.dynFieldsStatus,
        dynFieldsActivity:state.dynamicFields.dynFieldsActivity,
        dynFieldsAllItems:state.dynamicFields.dynFieldAllItems, 
        countryList:state.countryList.countryList,
        countryListStatus:state.countryList.countryListStatus,
        countryListActivity:state.countryList.countryListActivity,
        countryListErrorData:state.countryList.countryListErrorData,
        emailUpdated:state.crews.emailUpdated,
        timeZonesAllItems:state.timeZones.timezonesList,
        timezonesListStatus:state.timeZones.timezonesListStatus,
        timezonesListActivity:state.timeZones.timezonesListActivity,
        timezonesListErrorData:state.timeZones.timezonesListErrorData,
        payLevelList : state.payLevel.items,
        payLevelStatus : state.payLevel.status,
        payLevelActivity : state.payLevel.subactivity,
        

        validateResponse: state.validate.validateResponse,
        validateStatus: state.validate.validateStatus,
        validateActivity: state.validate.validateActivity,
        validateErrorData: state.validate.validateErrorData,
        fromExpiryCertificatesWindow:state.commons.fromExpiryCertificatesWindow

    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({     
        crewEditAction:id=>crewEditAction(id),
        crewBasicInfoAddAction:data=>crewBasicInfoAddAction(data),
        crewBasicInfoUpdateAction:data=>crewBasicInfoUpdateAction(data),
        aflt_departmentsListAction:aflt_departmentsListAction,
        crewActiveDeactiveAction:id=>crewActiveDeactiveAction(id),
        crewChangeAvailabilityAction:data=>crewChangeAvailabilityAction(data),
        crewApproveAction:data=>crewApproveAction(data),
        clearAction:clearAction,
        resendEmailAction:resendEmailAction,
        crewChiefEligibleAction:crewChiefEligibleAction,
        dynamicFieldsListAction:dynamicFieldsListAction,
        dynamicFieldsDataSaveAction:dynamicFieldsDataSaveAction,
        countryListAction:countryListAction, 
        timeZonesListAction:timeZonesListAction,
        crewInductionAction:crewInductionAction,
        payLevelsListAction:payLevelsListAction,
        validateCrewAddAction:validateCrewAddAction, 
        validateCrewDetailsAction:validateCrewDetailsAction,
        fromExpiryCertificates:fromExpiryCertificates,
        listVehicleInfo:listVehicleInfo,
    },dispatch);
}
export default connect(mapStateToProps,mapDispatchToProps)(CrewProfileComponent);
